import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
    MaxWidthWrapper,
    PageContentWrapperSection,
} from '../../components/LayoutContainer.ui'
import UserContext from '../../data/user'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Form from '../../components/FormCreator'
import LogoLink from './Logo'
import Button from '../../components/Button'
const LoginConfig = [
    { name: 'email', label: 'email', type: 'email', span: '1/-1' },
    { name: 'password', label: 'password', type: 'password', span: '1/-1' },
]
const InvitationAcceptPage = () => {
    const [hasError, setHasError] = useState(false)
    const userCtx = useContext(UserContext)
    const navigate = useNavigate()
    const api = userCtx.api
    const params = useParams()
    useEffect(() => {
        window.sessionStorage.setItem('invitation', params.token)
    }, [params.token])
    const parsedInvitation = useMemo(
        () => JSON.parse(window.atob(params.token.split('.')[1])),
        [params.token]
    )
    console.log(parsedInvitation)
    return (
        <>
            <h2>{parsedInvitation?.team} wants you to join! </h2>
            {userCtx.activeUser ? (
                <>
                    <p>{parsedInvitation?.member.nickName}, you are invited </p>
                    <p>
                        Click the button below to become a member of{' '}
                        {parsedInvitation?.team} on Huddles.
                    </p>
                    <Button
                        onClick={() =>
                            api
                                .acceptInvitation(params.token)
                                .then(() =>
                                    navigate(
                                        '/my/teams/' + parsedInvitation?.teamId
                                    )
                                )
                        }
                    >
                        Join {parsedInvitation?.team}
                    </Button>
                </>
            ) : (
                <>
                    You are currently not signed in to the platform. Please
                    either
                    <strong>
                        <Link to="/signup">Sign up </Link>
                    </strong>
                    or
                    <strong>
                        <Link to="/login">Log in </Link>
                    </strong>
                </>
            )}
        </>
    )
}

export default InvitationAcceptPage
